<template>
  <base-material-chart-card
    :data="chart.data"
    :options="chart.options"
    hover-reveal
    color="info"
    type="Line"
    :text="text"
  >
    <h3 class="card-title font-weight-light mt-2 ml-2">
      {{ title }}
    </h3>
    <template v-slot:heading>
      <v-icon
        class="mr-1"
        small
      />
      <span class="caption grey--text font-weight-light" />
    </template>
  </base-material-chart-card>
</template>

<script>
  export default {
    props: {
      levels: {
        type: Array,
        default: () => [],
      },
      title: {
        type: String,
        default: '',
      },
      option: {
        type: String,
        default: '',
      },
      text: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        high: 20,
        chart: {
          data: {
            labels: ['Nivel 1', 'Nivel 2', 'Nivel 3', 'Nivel 4', 'Nivel 5', 'Nivel 6', 'Nivel 7', 'Nivel 8'],
            series: [
              [],
            ],
          },
          options: {
            lineSmooth: this.$chartist.Interpolation.cardinal({
              tension: 0,
            }),
            low: 0,
            showArea: true,
            high: this.highComputed,
            chartPadding: {
              top: 20,
              right: 0,
              bottom: 0,
              left: 0,
            },
          },
        },
      }
    },
    computed: {
      highComputed () {
        return this.high
      },
    },
    watch: {
      levels (val) {
        this.init()
      },
    },
    mounted () {
      this.init()
    },
    methods: {
      init () {
        this.chart.data.series = []
        const series = []

        this.levels.map((data, i) => {
          if (data[this.option] === '99:99') {
            data[this.option] = 0
          }

          if (this.option === 'solve_time' && data.total_answered > 0) {
            const div = data[this.option] / data.total_answered
            series.push(div)
          } else if (this.option === 'solve_time') {
            series.push(data[this.option])
          }

          if (this.option === 'story_time' && data.text_count > 0) {
            const div = data[this.option] / data.text_count
            series.push(div)
          } else if (this.option === 'story_time') {
            series.push(data[this.option])
          }

          if (this.option === 'total_correct') {
            series.push(data[this.option])
          }
        })
        this.high = this.max(series)
        this.chart.data.series = [series]
      },
      max (input) {
        if (toString.call(input) !== '[object Array]') { return false }
        return Math.max.apply(null, input)
      },
    },
  }
</script>
